'use client'
import React, { useState } from 'react'
import { Box, Button, Flex, Image, Text } from '@chakra-ui/react'
import Link from 'next/link'
import CombineMoreInfo from '../modals/combine-more-info'

const GuestViewEarnings = () => {
  const [isCombineMoreInfoOpen, setCombineMoreInfoOpen] = useState(false)
  const handleCombineMoreInfoOpen = () => {
    setCombineMoreInfoOpen(true)
  }
  return (
    <>
      <CombineMoreInfo
        isOpen={isCombineMoreInfoOpen}
        onClose={() => setCombineMoreInfoOpen(false)}
      />

      <Box
        bg="linear-gradient(52.62deg, rgba(255, 255, 255, 0.2) 12.76%, rgba(36, 191, 163, 0.2) 110.86%)"
        boxShadow="0px 5px 9px -2px rgba(36, 191, 163, 0.40)"
        className="relative mb-6 rounded-xl bg-cover bg-no-repeat p-3 text-white sm:p-5"
      >
        <Flex justifyContent={'space-between'} alignItems={'center'}>
          <Text fontWeight={600} fontSize={[14, 14, 18]} color={'#727272'}>
            Your estimated total balance
          </Text>
          <Flex
            color={'lyk-green'}
            className="items-center text-sm font-semibold sm:text-[16px]"
          >
            More info{' '}
            <Image
              boxSize={5}
              src={'/rewards/breakdown/info-green.svg'}
              alt="Icon"
              marginLeft={'4px'}
              onClick={handleCombineMoreInfoOpen}
            />
          </Flex>
        </Flex>

        <hr className="my-4 font-semibold text-[#DDDDDD]" />

        <Flex className="w-full flex-col items-center justify-center gap-3">
          <Image
            src={'/rewards/user.svg'}
            alt="Icon"
            w={{ base: 10, sm: 12 }}
            h={{ base: 10, sm: 12 }}
            mb={1}
          />

          <Text
            fontWeight={600}
            color={'#727272'}
            fontSize={18}
            textAlign={'center'}
          >
            Sign Up on LYKSTAGE to start earning
          </Text>

          <Button
            width={'full'}
            size={'md'}
            bg={'lyk-green'}
            color={'white'}
            as={Link}
            _hover={{ opacity: 0.7 }}
            href={'/auth/signup'}
            className="max-sm:mb-2"
          >
            Get Started
          </Button>
        </Flex>
      </Box>
    </>
  )
}

export default GuestViewEarnings
